// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"243":"38354cbe","326":"0a81929b","335":"224577d1","633":"1ff6df7a"}[chunkId] + ".chunk.css";
};